import React, { useMemo, useRef } from "react";

import { HvDropdownProps } from "@hitachivantara/uikit-react-core";

import { Severity } from "lib/api";
import LevelBadge from "components/common/LevelBadge";
import BaseDropdown from "../BaseDropdown";

import useStyles from "./styles";

interface SeverityDropdownProps extends Omit<HvDropdownProps, "values"> {
  severities?: Severity[];
  defaultValue?: number;
}

const SeverityDropdown = ({
  severities,
  defaultValue,
  ...other
}: SeverityDropdownProps): JSX.Element => {
  const classes = useStyles();

  const initialSelectedRef = useRef(defaultValue);
  const dropdownValues = useMemo(
    () =>
      severities?.map((r) => ({
        id: r.pk_svrt_id.toString(),
        label: (
          <LevelBadge
            color={r.svrt_color}
            textIcon={`S${r.inc_severity_order}`}
            name={r.svrt_name}
          />
        ),
        searchValue: r.svrt_name,
        selected:
          initialSelectedRef.current != null
            ? initialSelectedRef.current === r.pk_svrt_id
            : r.svrt_is_default,
      })),
    [severities]
  );

  return (
    <BaseDropdown
      classes={{
        placeholder: classes.placeholder,
      }}
      values={dropdownValues}
      singleSelectionToggle={false}
      {...other}
    />
  );
};

export default SeverityDropdown;
